import {
  authenticate,
  configure,
  oAuthSignIn,
  emailSignIn,
  server,
  signOut,
  ui,
  user,
} from './auth/index';
import { combineReducers } from 'redux-immutablejs';

export default combineReducers({
  authenticate,
  configure,
  oAuthSignIn,
  emailSignIn,
  server,
  signOut,
  ui,
  user
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js